import React from 'react';
import './Home.css';

const Home = () => (
  <section className="section section-home">
    <h2 className="section-heading">Welcome to our page!</h2>
    <p className="desc">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis,
      modi accusamus. Nostrum autem et labore eveniet tempora voluptatem,
      eligendi aliquam, fugit ipsum nisi accusamus, itaque architecto nemo omnis nobis distinctio?
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis,
      modi accusamus. Nostrum autem et labore eveniet tempora voluptatem,
      eligendi aliquam, fugit ipsum nisi accusamus, itaque architecto nemo omnis nobis distinctio?
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis,
      modi accusamus. Nostrum autem et labore eveniet tempora voluptatem,
      eligendi aliquam, fugit ipsum nisi accusamus, itaque architecto nemo omnis nobis distinctio?
      <br />
      <br />
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis,
      modi accusamus. Nostrum autem et labore eveniet tempora voluptatem,
      eligendi aliquam, fugit ipsum nisi accusamus, itaque architecto nemo omnis nobis distinctio?
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis,
      modi accusamus. Nostrum autem et labore eveniet tempora voluptatem,
      eligendi aliquam, fugit ipsum nisi accusamus, itaque architecto nemo omnis nobis distinctio?
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis,
      modi accusamus. Nostrum autem et labore eveniet tempora voluptatem,
      eligendi aliquam, fugit ipsum nisi accusamus, itaque architecto nemo omnis nobis distinctio?
    </p>
  </section>
);

export default Home;
